import { render, staticRenderFns } from "./SwiperParallax.vue?vue&type=template&id=7759d3b2&"
import script from "./SwiperParallax.vue?vue&type=script&lang=js&"
export * from "./SwiperParallax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports